import React from "react";
import { Popup } from "../../../components";

/**
 * Render the delete dialog for a node.
 * If the node is a folder with children, inform the user about the relocation of the page
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {boolean} props.isDeleting
 * @param {import("../types").InfoNode | null} props.node
 * @param {() => void} props.onConfirm
 * @param {() => void} props.onCancel
 */
export function NodeDeleteDialog({
	isOpen,
	isDeleting = false,
	node,
	onConfirm,
	onCancel,
}) {
	if (!isOpen || !node) return null;
	const isFolder = node.type === "folder";
	const quotedTitle = node.title ? `"${node.title}"` : "this item";

	return (
		<Popup
			title={`Delete ${isFolder ? "folder" : "page"}`}
			minWidth={420}
			maxWidth={520}
			hasPadding
			onClose={onCancel}
			buttons={[
				{
					type: "primary",
					onClick: onConfirm,
					isActive: !isDeleting,
					text: isDeleting ? "Deleting…" : "Delete",
				},
				{
					type: "tertiary",
					onClick: onCancel,
					isActive: !isDeleting,
					text: "Cancel",
				},
			]}
		>
			{isFolder ? (
				<>
					<p>
						Deleting the folder <strong>{quotedTitle}</strong> removes it from
						the list. Pages inside this folder are kept and return to the main
						list.
					</p>
					<p>This action cannot be undone.</p>
				</>
			) : (
				<>
					<p>
						Deleting the page <strong>{quotedTitle}</strong> permanently removes
						it.
					</p>
					<p>This action cannot be undone.</p>
				</>
			)}
		</Popup>
	);
}
